import http from '@/utils/http';

export default {
  list: (data) => http({ url: '/api/admin/v1/userCancel/list', data }),
  detail: (data) => http({ url: '/api/admin/v1/userCancel/detail', data }),
  audit: (data) => http({ url: '/api/admin/v1/userCancel/audit', data, tip: true }),
};
